import React from 'react';
import WorkspaceItemContext from '../contexts/workspace/workspace-item-context';

import { Map as MaplibreMap } from 'maplibre-gl';

export type MapExtended = MaplibreMap & { isLightStyle?: boolean };
const useMap = () => {
    return React.useContext(WorkspaceItemContext).map;
};

const useMapIsLight = () => {
    const map = useMap();
    const [isLight, setIsLight] = React.useState(() => map?.isLightStyle ?? false);
    React.useEffect(() => {
        setIsLight(map?.isLightStyle ?? false);
        return map?.onThemeChanged((e) => {
            setIsLight(e.isLight);
        }).unsubscribe;
    }, [map]);

    return isLight;
};
export default useMap;
export { useMapIsLight };
